import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { GridApi } from 'ag-grid-community';
import { AgGridColumnTreeComponent } from '../ag-grid-column-tree/ag-grid-column-tree.component';

export interface WilsonAgGridColumnOptionModalInput {
  gridUniqueId: string;
  gridApi: GridApi;
  hideColumnVisibilityMenu?: boolean;
  centerHeader?: boolean;
}

@Component({
  selector: 'wilson-ag-grid-column-option-modal',
  imports: [AgGridColumnTreeComponent],
  templateUrl: './ag-grid-column-option-modal.component.html',
  styleUrl: './ag-grid-column-option-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgGridColumnOptionModalComponent {
  private data = inject<WilsonAgGridColumnOptionModalInput>(NZ_MODAL_DATA);

  protected gridUniqueId = this.data.gridUniqueId;
  protected gridApi = this.data.gridApi;
}
